// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

// TherapyRefTag — the display-only "Enrollment ref" (ASP #25) under a patient's name on the CareRx
// worklists and headers. Shared in components/ui because four screens show it (E-01). Pass either
// the therapy id (formatted here) or refs the server already formatted (the patient-grain queue).

import { THERAPY_REF_LABEL, therapyRef } from '../../lib/therapyRef'

export default function TherapyRefTag({ therapyId, refs }: { therapyId?: string | null; refs?: string[] | null }) {
  const shown = refs?.length ? refs : [therapyRef(therapyId)].filter((r): r is string => !!r)
  if (shown.length === 0) return null
  return (
    <span title={`${THERAPY_REF_LABEL} — for reference only, not unique`} data-testid="therapy-ref"
      style={{ fontFamily: 'ui-monospace, monospace', fontSize: 10.5, color: 'var(--color-text-soft, #57534e)', whiteSpace: 'nowrap' }}>
      {shown.join(', ')}
    </span>
  )
}
